/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonCompanyDepartmentInfo,
    JsonCompanyDepartmentInfoFromJSON,
    JsonCompanyDepartmentInfoFromJSONTyped,
    JsonCompanyDepartmentInfoToJSON,
} from './JsonCompanyDepartmentInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonCompanyDepartmentInfo
 */
export interface ApiResultOfJsonCompanyDepartmentInfo {
    /**
     * 
     * @type {JsonCompanyDepartmentInfo}
     * @memberof ApiResultOfJsonCompanyDepartmentInfo
     */
    data?: JsonCompanyDepartmentInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompanyDepartmentInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonCompanyDepartmentInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompanyDepartmentInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompanyDepartmentInfo
     */
    result?: ApiResultOfJsonCompanyDepartmentInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonCompanyDepartmentInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonCompanyDepartmentInfoFromJSON(json: any): ApiResultOfJsonCompanyDepartmentInfo {
    return ApiResultOfJsonCompanyDepartmentInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonCompanyDepartmentInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonCompanyDepartmentInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonCompanyDepartmentInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonCompanyDepartmentInfoToJSON(value?: ApiResultOfJsonCompanyDepartmentInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonCompanyDepartmentInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

